import React from "react";
import classNames from "classnames";
import { CardTitle } from "./card-title";

interface CardBodyProps {
    className?: string;
    title?: string;
    [x: string]: any;
}

export const CardBody = ({ className, title, ...props }: CardBodyProps) => {
    return (
        <div className={classNames("card-body", className)} {...props}>
            {!!title && <CardTitle>{title}</CardTitle>}
            {props.children}
        </div>
    );
};
